<template>
    <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
  
      <ul>
        <li v-for="header in activeHeaders" :key="header" class="flex">
          <img alt="" class="w-6 mr-2" src="@/assets/images/billing/fleets-icon.svg" />
          <div class="flex items-center justify-between filter-item ml-4">
            <span>{{ header.name }}</span>
            <span>
                <activeEye />
            </span>
          </div>
        </li>
      </ul>
  
      <div class="divider"></div>
  
      <ul>
        <li v-for="header in inactiveHeaders" :key="header" class="flex">
          <img alt="" class="w-6 mr-2" src="@/assets/images/billing/fleets-icon.svg" />
          <div class="flex items-center justify-between filter-item ml-4">
            <span>{{ header.name }}</span>
            <span @click="toggleHeader(header, 'active')" class="cursor-pointer">
              <eyes />
            </span>
          </div>
        </li>
      </ul>
  
    </modal>
  </template>
  
  <script>
  import activeEye from "@/assets/images/billing/active-eye.vue";
  import eyes from "@/assets/images/billing/eyes.vue";
  export default {
    components: {
      activeEye,
      eyes,
    },
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
      activeHeaders: {
        type: Array
      }
    },
    data() {
      return {  
        inactiveHeaders: [
          { name: "Channel" },
          { name: "Top distance" },
          { name: "Load weight" },
          { name: "Income" }
        ], 
      };
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
      toggleHeader(header, status) {
        if (status === 'active') {
          // Move from inactive to active
          this.activeHeaders.push(header);
          this.inactiveHeaders = this.inactiveHeaders.filter(h => h !== header);
        } 
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  ul>li>div{
    width: 100%;
  }
  
  .label {
    @apply border-b-2 border-gray-400 w-full pb-1;
    font-size: 13px;
  }
  .individual-contaoner {
    @apply w-full border-2 border-gray-300 border-dashed p-2 my-3;
  }
  .filter-search {
    border-radius: 4px;
    @apply py-2;
  }
  .filter-item{
    @apply py-2 opacity-75
  }
  .divider{
      @apply border-gray-300 w-full;
      border-top-width: 1px;
    }
  </style> 
  